function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "g4495"
});

var SvgPlattegrond = function SvgPlattegrond(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "100 30  600 520",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5703",
    d: "m 182.29,25.3 c 14.84,-0.19 29.68,-0.25 44.52,-0.11 -0.03,19.12 0.31,38.25 -0.18,57.37 -14.73,0.13 -29.46,0.15 -44.19,-0.01 -0.27,-19.08 0.04,-38.16 -0.15,-57.25 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5705",
    d: "m 223.79,106.86 c 1.47,0 2.94,0 4.42,0.01 0.3,24.37 0.04,48.75 0.12,73.13 -0.09,15.37 0.19,30.74 -0.14,46.11 -1.47,-0.01 -2.93,-0.03 -4.39,-0.03 -0.33,-31.02 -0.05,-62.05 -0.14,-93.08 0.06,-8.71 -0.15,-17.43 0.13,-26.14 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5709",
    d: "m 167.31,212.03 c 9.63,7.17 18.45,15.35 27.86,22.81 1.96,1.66 4.21,3.12 5.61,5.32 -0.12,1.94 -1.65,3.42 -2.71,4.94 -8.58,10.1 -17.02,20.31 -25.51,30.49 -2.3,2.67 -4.22,5.75 -7.03,7.93 -1.89,0.9 -3.58,-1.12 -5.07,-2.01 -7.99,-6.68 -15.9,-13.46 -24.02,-19.99 -2,-1.66 -4.07,-3.36 -5.41,-5.63 0.89,-2.22 2.53,-4.01 4.06,-5.8 10.92,-12.53 21.02,-25.78 32.22,-38.06 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5711",
    d: "m 228.09,234.18 c 29.99,0.09 59.99,0.13 89.98,-0.01 -0.01,1.3 -0.01,2.61 0.01,3.91 -20.01,0.57 -40.05,0.09 -60.08,0.25 -10.07,-0.11 -20.14,0.22 -30.2,-0.2 0.09,-1.32 0.19,-2.64 0.29,-3.95 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5713",
    d: "m 372.02,234.15 c -0.5,1.6 -1.06,3.18 -1.68,4.74 -7.93,-1.25 -44.32,0.1 -52.26,-0.81 -0.11,-0.7 0.1,-3.21 -0.01,-3.91 17.80242,-0.0666 37.72228,0.27686 53.95,-0.02 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5715",
    d: "m 343.24,236.12 c 3.06,-1.54 0.21,3.27 0,0 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5723",
    d: "m 405.38,304.39 c 0.02,0.13 0.07,0.39 0.09,0.52 l -0.23,-0.34 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5727",
    d: "m 210.17,349.27 c 3.35,0.19 -1.59,2.98 0,0 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5729",
    d: "m 208.18,351.44 c 1.4,-0.43 1.89,0.05 1.49,1.45 -1.41,0.43 -1.91,-0.05 -1.49,-1.45 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5731",
    d: "m 213.32,354.31 c 1.77,-0.69 1.92,2.13 0.39,2.44 -1.78,0.69 -1.92,-2.13 -0.39,-2.44 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5733",
    d: "m 225.14,364.38 c 1.88,-0.7 2.15,2.29 0.5,2.67 -1.94,0.81 -2.19,-2.33 -0.5,-2.67 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    },
    id: "path5735",
    d: "m 371.21,431.99 c 3.05,-1.51 0.19,3.33 0,0 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000",
      strokeWidth: 1.33333337
    },
    d: "M 523.02539 300.33008 C 523.72083 300.92545 524.7832 301.89648 524.7832 301.89648 L 525.02539 301.83203 C 524.36339 301.32289 523.65015 300.89103 523.02539 300.33008 z ",
    id: "path176",
    transform: "scale(0.74999999)"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000",
      strokeWidth: 1.33333337
    },
    d: "M 521.98633 299.40625 C 521.61189 299.03256 521.26797 298.62379 520.9043 298.23633 C 521.12273 298.48064 521.27419 298.74131 521.50195 298.97461 C 521.73689 299.21526 521.75282 299.18338 521.98633 299.40625 z ",
    id: "path174",
    transform: "scale(0.74999999)"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000",
      strokeWidth: 1.33333337
    },
    d: "M 522.47852 299.8457 C 522.46211 299.83092 522.45987 299.82744 522.44336 299.8125 C 522.43647 299.83146 522.43268 299.86195 522.42578 299.88086 L 522.47852 299.8457 z ",
    id: "path172",
    transform: "scale(0.74999999)"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000"
    },
    id: "path5836",
    d: "m 256.81,257.35 c 19.37,0.03 38.75,0.04 58.12,-0.01 0.2,28.7 -0.05,57.39 0.01,86.08 -19.37,-0.05 -38.73,-0.04 -58.1,-0.01 -0.09,-28.68 -0.03,-57.37 -0.03,-86.06 m 1.04,1.05 c -0.01,27.99 0.01,55.98 0.02,83.96 18.7,0.02 37.4,0.03 56.11,0 -0.02,-27.98 -0.03,-55.96 0,-83.95 -18.71,-0.06 -37.42,-0.03 -56.13,-0.01 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#64350f"
    },
    id: "path6123",
    d: "m 231.83,107.78 c 4.11,-0.04 8.23,-0.04 12.35,0 0,17.04 0.01,34.08 -0.01,51.13 -4.11,-0.02 -8.23,-0.02 -12.34,-0.01 -0.02,-17.04 -0.01,-34.08 0,-51.12 z"
  }), React.createElement("g", {
    id: "kantine",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 223.16,240.91 c 8.57105,8.65747 9.19567,8.60483 24.30469,21.17251 -2.63,3.91 -8.51469,11.01749 -11.41469,14.71749 -2.96,-2.42 -5.87,-4.89 -8.85,-7.27 -6.69,8.07 -13.47,16.07 -20.13,24.16 5.21,4.32 10.43,8.61 15.56,13.02 -4,4.8 -8.02,9.57 -11.99,14.4 -9.48,-7.74 -18.78,-15.71 -28.25,-23.46 -1.27,-1.08 -2.6,-2.14 -3.58,-3.49 14.66,-17.85 29.6,-35.47 44.35,-53.25 z",
    id: "path6127",
    style: {
      opacity: 1,
      fill: "#64350f"
    }
  })), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#64350f"
    },
    id: "path6133",
    d: "m 462.5,265.24 c 6.78,-0.04 13.56,0 20.34,-0.03 0.02,6.82 0.02,13.63 0,20.45 -6.78,-0.04 -13.56,-0.02 -20.33,-0.02 0.04,-6.8 0.05,-13.6 -0.01,-20.4 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#64350f"
    },
    id: "path6135",
    d: "m 484.8,265.26 c 6.78,-0.05 13.57,-0.06 20.36,0 -0.02,4.39 -0.05,8.77 -0.11,13.16 -2.25,0.01 -4.5,0.01 -6.75,-0.01 -0.04,2.42 -0.07,4.84 -0.12,7.26 -4.45,-0.05 -8.9,-0.05 -13.34,0 -0.09,-6.81 -0.04,-13.61 -0.04,-20.41 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#64350f"
    },
    id: "path6141",
    d: "m 239.17,289.16 c 0.63,0.63 0.63,0.63 0,0 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#64350f"
    },
    id: "path6159",
    d: "m 228.18,367.48 c 0.83,-0.93 1.86,-2.75 3.31,-2.35 0.1,1.6 -1.9,3.93 -3.54,3.69 0.06,-0.34 0.17,-1 0.23,-1.34 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#64350f"
    },
    id: "path6169",
    d: "m 350.75,402.46 c 3.69,-4.39 7.49,-8.69 11.31,-12.96 1.46,1.3 2.91,2.61 4.32,3.97 0.88,-0.5 1.77,-1 2.66,-1.49 2.81,2.46 5.6,4.96 8.49,7.33 -0.13,1.1 -0.33,2.21 -0.32,3.34 3.69,3.56 7.75,6.73 11.52,10.22 -3.8,4.32 -7.56,8.69 -11.39,12.99 -4.79,-3.67 -8.53,-9.14 -14.51,-10.9 -3.16,-2.35 -6.62,-4.79 -8.28,-8.49 -0.93,-1.62 -2.5,-2.72 -3.8,-4.01 z"
  }), React.createElement("g", {
    id: "400 meterbaan",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 562.02844,248.0363 c -0.88365,0.0136 -1.76719,0.045 -2.64844,0.0937 -17.53464,5.24908 -33.57756,9.97569 -44.06982,27.24024 -8.26,12.58 -9.02006,28.02017 -12.81005,42.18017 -1.58001,5.8 -6.91059,9.94981 -12.60059,11.29981 -6.62,1.53 -13.60937,-0.3108 -20.10937,1.92919 -9.42,3.13001 -17.92977,11.71137 -17.75977,22.15137 -0.34,26.46 -1.26974,52.90988 -1.48975,79.37988 7.59,10.75001 14.37912,22.28909 18.59912,34.80908 0.55,5.82 -1.11006,11.67024 -1.56006,17.49024 1.34001,11.4 4.67016,22.86039 11.66016,32.15039 23.02363,26.75097 60.33087,30.75482 85.19092,9.62989 9.6,-8.25 16.32865,-19.72989 18.86865,-32.12989 12.79,-58.84 25.67113,-117.65953 38.41114,-176.51953 4.62999,-21.55 -4.66085,-45.09035 -22.36085,-58.11035 -10.64062,-8.03437 -24.06646,-11.79796 -37.32129,-11.59424 z m 2.14014,17.63527 c 5.75878,-0.0553 11.52863,1.06431 16.80176,3.40869 13.11,5.66 22.85998,18.64944 24.22998,32.91944 0.7,6.24 -0.37992,12.49007 -1.66992,18.58007 -12.25,56.11 -24.41994,112.23985 -36.68994,168.33985 -16.11929,38.12688 -63.98552,44.81304 -78.68994,7.94091 -3.44,-8.52 -3.07035,-18.02033 -1.11035,-26.84033 12.51999,-57.19 24.83968,-114.42033 37.42968,-171.59033 3.26,-15.67 16.0799,-28.93996 31.8999,-31.95996 2.56563,-0.50625 5.1812,-0.77323 7.79883,-0.79834 z",
    style: {
      opacity: 1,
      fill: "#b3b3b3",
      strokeWidth: 1
    },
    id: "path6206"
  })), _ref2, React.createElement("g", {
    id: "veld 1",
    className: "selectable"
  }, React.createElement("g", {
    id: "g6401"
  }, React.createElement("path", {
    id: "path6227",
    d: "m 246.09,37.93 c 28.63,0.38 57.28,0.06 85.91,0.16 12.97,-0.1 25.94,0.22 38.9,-0.16 l -0.1,0.59 c -0.4,2.12 -0.64,4.28 -0.69,6.44 0,59.79 0.09,119.58 -0.04,179.37 -41.06,0.14 -82.12,0.15 -123.17,0 -0.17,-55.44 0,-110.89 -0.08,-166.33 -0.12,-6.49 0.51,-13.04 -0.63,-19.47 l -0.1,-0.6 m 2.88,4.02 c -0.01,60.02 -0.01,120.05 0.01,180.07 39.66,0.04 79.33,0.05 118.99,0 0.03,-60.02 0,-120.05 0.02,-180.07 -39.67,-0.05 -79.34,-0.04 -119.02,0 z",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  })), React.createElement("path", {
    d: "m 250.18,43.13 c 10.59,-0.01 21.18,0.01 31.77,-0.02 0.06,7.54 -0.06,15.07 0.09,22.6 3.55,0.02 7.16,-0.4 10.69,0.22 2.43,2.36 4.44,5.28 7.57,6.8 5.67,3.07 13.03,2.64 18.28,-1.12 2.19,-1.57 3.77,-3.79 5.73,-5.61 3.46,-0.78 7.09,-0.22 10.62,-0.28 0.1,-7.54 -0.02,-15.08 0.1,-22.61 10.59,0.04 21.18,0 31.77,0.02 -0.05,29.39 -0.05,58.78 0,88.17 -13.3,0.12 -26.59,0.05 -39.89,0.04 -0.86,-5.24 -2.92,-10.6 -7.41,-13.79 -6.98,-5.53 -18.02,-4.69 -24.04,1.89 -3.24,3.13 -4.49,7.6 -5.27,11.9 -13.34,0.01 -26.68,0.07 -40.02,-0.04 0.06,-29.39 0.04,-58.78 0.01,-88.17",
    id: "path6229",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 283.17,43.12 c 16.86,0.02 33.72,-0.01 50.59,0.01 -0.04,7.06 -0.06,14.12 0.02,21.17 -16.88,0.1 -33.76,0.08 -50.63,0.01 0.07,-7.06 0.04,-14.13 0.02,-21.19 z",
    id: "path6231",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 294.5,65.81 c 9.35,-0.26 18.71,-0.26 28.05,0 -3.1,4.38 -8.03,7.65 -13.54,7.63 -5.84,0.37 -11.23,-2.98 -14.51,-7.63 z",
    id: "path6245",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 300.96,116.96 c 6.6,-3.52 15.34,-1.75 20.19,3.89 2.67,2.83 3.72,6.69 4.36,10.43 -11.31,0.13 -22.63,0.12 -33.94,0 0.61,-5.93 3.9,-11.69 9.39,-14.32 z",
    id: "path6257",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 250.18,132.7 c 13.33,-0.12 26.66,-0.01 39.99,-0.05 0.84,4.98 2.73,10.05 6.85,13.24 6.74,5.8 17.71,5.39 24.02,-0.88 3.56,-3.14 5.01,-7.82 5.86,-12.34 13.3,-0.01 26.6,-0.08 39.9,0.04 -0.07,29.35 -0.01,58.7 -0.03,88.05 -10.58,-0.01 -21.15,-0.04 -31.73,0.01 -0.13,-7.52 -0.02,-15.04 -0.09,-22.56 -3.58,0.02 -7.16,0.02 -10.73,-0.04 -3.55,-5.4 -9.56,-9.48 -16.23,-9.06 -6.33,-0.03 -11.73,4.05 -15.17,9.07 -3.6,0.05 -7.2,0.04 -10.8,0.03 -0.12,7.52 -0.01,15.04 -0.08,22.56 -10.58,-0.04 -21.15,-0.03 -31.73,-0.01 -0.04,-29.35 0.03,-58.7 -0.03,-88.06 z",
    id: "path6263",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 291.6,132.72 c 11.3,-0.1 22.61,-0.13 33.91,0.02 -0.67,6.18 -4.34,12.1 -10.19,14.56 -7.17,3.34 -16.38,0.66 -20.68,-5.96 -1.86,-2.5 -2.47,-5.62 -3.04,-8.62 z",
    id: "path6265",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 294.5,198.08 c 2.78,-3.77 6.73,-6.89 11.51,-7.47 6.44,-1.19 12.97,2.14 16.54,7.47 -9.35,0.23 -18.7,0.23 -28.05,0 z",
    id: "path6275",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 283.15,199.61 c 16.87,-0.08 33.75,-0.14 50.62,0.03 -0.07,7.04 -0.04,14.07 -0.03,21.11 -16.84,0.01 -33.69,-0.03 -50.54,0.02 -0.03,-7.05 0.02,-14.11 -0.05,-21.16 z",
    id: "path6281",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  })), React.createElement("g", {
    id: "veld 2",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 396.05,51.24 c 10,0.05 20,0.03 30,0.01 0.14,7.15 0.02,14.3 0.1,21.46 3.25,-0.04 6.52,-0.24 9.77,0.05 2.05,1.67 3.54,3.96 5.71,5.51 6.17,4.61 15.71,4.07 21.15,-1.47 1.49,-1.28 2.53,-3.15 4.33,-4.03 3.18,-0.3 6.38,-0.1 9.58,-0.09 0,-7.15 -0.07,-14.3 0.06,-21.45 10.01,0.06 20.02,0.04 30.03,0.02 0.03,27.93 -0.02,55.87 0.02,83.81 -12.62,0.1 -25.24,0.03 -37.86,0.04 -0.82,-4.47 -2.34,-9.06 -5.9,-12.11 -6.22,-5.92 -16.86,-5.97 -23.15,-0.12 -3.64,3.04 -5.21,7.69 -6.04,12.2 -12.62,0.07 -25.23,0.05 -37.85,0.01 0.04,-27.95 -0.06,-55.9 0.05,-83.84",
    id: "path6237",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 392.79,47.8 c 39.07,-0.1 78.14,-0.09 117.2,0 0.08,58.66 0.15,117.33 -0.03,176 -39.04,-0.06 -78.08,-0.05 -117.12,0 -0.2,-58.67 -0.11,-117.34 -0.05,-176 m 1.99,2.18 c 0.01,57.21 -0.13,114.41 0.06,171.62 37.7,-0.01 75.4,-0.02 113.1,0 0.19,-57.2 0.06,-114.41 0.07,-171.62 -37.75,-0.04 -75.49,-0.05 -113.23,0 z",
    id: "path6233",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 427.37,51.27 c 15.96,-0.04 31.93,0.04 47.9,-0.04 0.11,6.7 0.07,13.4 0.04,20.09 -15.99,0 -31.97,0.16 -47.95,-0.08 0.06,-6.65 0.05,-13.31 0.01,-19.97 z",
    id: "path6239",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 438.16,72.81 c 8.83,-0.26 17.68,-0.27 26.52,0.01 -4.19,6.47 -13.17,9.32 -20.13,5.73 -2.66,-1.23 -4.65,-3.45 -6.39,-5.74 z",
    id: "path6247",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 456.22,101.77 c -2.11,-1.39 -3.19,-4.29 -0.07,-5.21 0.97,1.66 0.67,3.49 0.07,5.21 z",
    id: "path6253",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 441.94,122.87 c 6.05,-4.62 15.38,-3.96 20.68,1.53 3.01,2.74 4.26,6.76 4.9,10.66 -10.75,0.08 -21.5,0.08 -32.25,0 0.63,-4.7 2.66,-9.41 6.67,-12.19 z",
    id: "path6259",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 396.07,136.34 c 12.56,0.08 25.12,0.07 37.69,0 0.92,4.41 2.36,8.99 5.87,12.04 6.29,6.17 17.4,6.16 23.63,-0.1 3.46,-3.05 4.83,-7.57 5.78,-11.91 12.58,0.02 25.15,0.05 37.73,-0.02 0.05,27.94 -0.02,55.89 0.04,83.83 -10.04,0.08 -20.07,0.03 -30.1,0.03 -0.06,-7.13 -0.06,-14.27 0,-21.4 -3.44,-0.06 -6.88,-0.06 -10.32,-0.11 -3.4,-5.09 -9.1,-8.89 -15.4,-8.6 -6.03,-0.06 -11.25,3.76 -14.52,8.58 -3.46,0.08 -6.91,0.07 -10.37,0.1 0.03,7.14 0.02,14.27 0.01,21.41 -10.04,0.05 -20.07,0.04 -30.11,0.01 0.06,-27.95 -0.07,-55.91 0.07,-83.86 z",
    id: "path6267",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 435.18,136.54 c 10.74,-0.35 21.49,-0.06 32.24,-0.16 -0.27,9.1 -9.14,16.72 -18.2,15.21 -7.61,-0.85 -13.2,-7.67 -14.04,-15.05 z",
    id: "path6269",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 437.88,198.68 c 2.69,-3.15 5.94,-6.17 10.17,-6.92 6.32,-1.52 13.06,1.54 16.59,6.88 -8.91,0.2 -17.84,0.13 -26.76,0.04 z",
    id: "path6277",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 427.35,200.08 c 15.99,-0.12 31.97,-0.01 47.96,-0.06 0.05,6.73 0.04,13.46 0.01,20.18 -15.99,-0.01 -31.98,0.11 -47.96,-0.06 0.06,-6.69 0.07,-13.38 -0.01,-20.06 z",
    id: "path6283",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  })), React.createElement("g", {
    id: "veld 3",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 572.46,102.34 c -0.85,-3.17 -0.75,-6.48 0.07,-9.63 0.3,3.2 0.29,6.43 -0.07,9.63 z",
    id: "path5772",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    d: "m 577.66,95.45 c 0.6,-0.84 1.2,-1.68 1.81,-2.52 -0.02,2.98 0.01,5.97 0.07,8.96 -1.76,-0.32 -5,0.39 -5.17,-2.17 -0.66,-2.33 1.71,-3.25 3.29,-4.27 m 0.46,6.13 c 0.03,-1.74 0.02,-3.49 -0.03,-5.23 -3.24,0.65 -3.23,4.64 0.03,5.23 z",
    id: "path5774",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    d: "m 558.49,93.5 c 1.26,2.08 2.15,4.35 3,6.62 1.02,-2.17 2.03,-4.35 3.32,-6.38 -0.71,3 -1.8,5.9 -3.09,8.69 -1.59,-2.76 -2.75,-5.77 -3.23,-8.93 z",
    id: "path5780",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    d: "m 583.38,95.04 c 1.39,-0.43 2.8,-0.83 4.21,-1.21 0.39,2.47 0.76,4.95 1.13,7.44 -1.8,0.32 -3.63,0.28 -5.39,-0.23 1.3,-0.11 2.6,-0.2 3.91,-0.28 -0.09,-0.61 -0.27,-1.85 -0.36,-2.47 -0.92,-0.19 -1.83,-0.38 -2.73,-0.56 1.15,-0.77 2.32,-1.54 3.47,-2.34 -1.42,-0.12 -2.83,-0.24 -4.24,-0.35 z",
    id: "path5782",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    d: "m 515.76,47.81 c 39.07,-0.11 78.14,-0.13 117.2,0.01 -0.04,58.66 0.06,117.32 -0.05,175.97 -39.04,-0.04 -78.08,-0.05 -117.11,0.01 -0.23,-58.66 -0.16,-117.33 -0.04,-175.99 m 1.92,2.19 c -0.02,57.2 -0.15,114.4 0.07,171.6 37.71,-0.01 75.42,-0.03 113.13,0.01 0.15,-57.2 0.02,-114.4 0.07,-171.59 C 593.19,49.9 555.44,49.92 517.68,50 Z",
    id: "path6235",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 519.02,51.25 c 9.97,0.02 19.95,0.04 29.93,-0.01 0.17,7.15 0.02,14.31 0.13,21.46 3.34,-0.05 6.69,-0.05 10.04,-0.07 1.96,2.41 3.93,4.95 6.7,6.5 5.17,3.04 12.03,3 17.13,-0.18 2.51,-1.54 4.21,-4 6.35,-5.98 3.38,-0.69 6.88,-0.22 10.32,-0.31 -0.03,-7.14 -0.11,-14.28 0.06,-21.43 10.01,0.07 20.01,0.02 30.02,0.04 -0.03,27.92 -0.04,55.84 0.01,83.76 -12.71,0.11 -25.43,0.16 -38.14,-0.03 -0.55,-5.93 -3.78,-11.69 -9.18,-14.47 -7.22,-4.09 -17.17,-1.85 -21.97,4.91 -2.15,2.77 -2.97,6.25 -3.63,9.62 -12.62,0.1 -25.24,0.04 -37.85,0.03 0.02,-27.95 -0.13,-55.89 0.08,-83.84",
    id: "path6241",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 550.27,51.26 c 15.99,-0.01 31.98,0.04 47.97,-0.03 0.08,6.7 0.04,13.4 0.03,20.09 -16.01,0.05 -32.03,0.08 -48.04,-0.02 0.08,-6.68 0.04,-13.36 0.04,-20.04 z",
    id: "path6243",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 561.01,72.82 c 8.84,-0.27 17.69,-0.27 26.52,-0.01 -2.91,4.05 -7.42,7.16 -12.54,7.27 -5.6,0.41 -10.89,-2.71 -13.98,-7.26 z",
    id: "path6249",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 578.12,101.58 c -3.26,-0.59 -3.27,-4.58 -0.03,-5.23 0.05,1.74 0.06,3.49 0.03,5.23 z",
    id: "path6255",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 564.33,123.24 c 5.87,-4.84 15.2,-4.57 20.68,0.75 3.22,2.79 4.69,6.95 5.31,11.06 -10.74,0.11 -21.48,0.08 -32.22,0.01 0.78,-4.46 2.45,-9.04 6.23,-11.82 z",
    id: "path6261",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 519.05,136.34 c 12.55,0.07 25.1,0.08 37.65,0 0.87,4.44 2.34,9.03 5.87,12.1 5.98,5.77 16.22,6.1 22.55,0.7 3.97,-3.05 5.82,-7.95 6.54,-12.76 12.67,-0.01 25.34,0.05 38.02,-0.03 0.03,27.93 -0.04,55.87 0.03,83.8 -10.03,0.15 -20.06,0.05 -30.09,0.05 -0.06,-7.18 -0.04,-14.36 -0.02,-21.54 -3.46,0.11 -6.93,0.11 -10.39,-0.01 -3.46,-5.39 -9.66,-9.12 -16.18,-8.51 -5.7,0.25 -10.53,3.95 -13.61,8.53 -3.46,0.09 -6.93,0.08 -10.39,0.1 0.01,7.14 0.02,14.29 -0.01,21.43 -10.03,0.03 -20.05,0.03 -30.08,0 0.04,-27.95 -0.16,-55.91 0.11,-83.86 z",
    id: "path6271",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 558.08,136.44 c 10.73,-0.11 21.45,-0.04 32.18,-0.05 -0.4,8.7 -8.38,16.16 -17.16,15.3 -8.05,-0.39 -14.25,-7.48 -15.02,-15.25 z",
    id: "path6273",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 560.85,198.68 c 2.64,-3.22 5.95,-6.2 10.2,-6.93 6.31,-1.5 12.95,1.61 16.53,6.87 -8.91,0.24 -17.82,0.14 -26.73,0.06 z",
    id: "path6279",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 550.25,200.06 c 16,-0.07 32,0 48.01,-0.04 0.04,6.73 0.04,13.46 0,20.19 -16.01,-0.01 -32.01,0.07 -48.01,-0.04 0.04,-6.7 0.04,-13.41 0,-20.11 z",
    id: "path6285",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  })), React.createElement("g", {
    id: "wielerbaan",
    style: {
      fill: "#b3b3b3",
      fillOpacity: 1
    },
    className: "selectable"
  }, React.createElement("g", {
    className: "",
    id: "",
    style: {
      fill: "#b3b3b3",
      fillOpacity: 1
    }
  }, React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#b3b3b3",
      fillOpacity: 1
    },
    id: "path5826",
    d: "m 371.27,248.51 c 3.88,-0.58 7.82,-0.21 11.73,-0.29 58.79,-0.06 121.89893,0.0537 180.68893,-0.15629 -15.24173,3.59493 -17.04934,9.88913 -30.31893,8.63629 -52.8,-0.1 -105.61,-0.03 -158.41,-0.03 -6.29,-0.18 -12.49,3.21 -15.66,8.65 -3.12,5.09 -3.31,11.71 -0.64,17.04 2.08,4.23 3.59,8.82 3.51,13.59 0,17.01 0.01,34.03 -0.01,51.04 0.06,3.44 -0.46,6.98 0.6,10.33 2.16,7.23 7.56,13.44 14.48,16.48 29.8,11.21 54.69,33.02 73.3,58.51 7.59,10.75 14.38,22.29 18.6,34.81 0.55,5.82 -1.11,11.67 -1.56,17.49 -6.56,-17.52 -14.04,-34.91 -25.04,-50.16 -16.9,-24.2 -41.68,-42.16 -68.92,-53.06 -11.79,-4.62 -19.31,-16.93 -19.8,-29.34 -0.04,-18.69 0.09,-37.39 -0.06,-56.08 0.15,-6.56 -4.73,-11.77 -5.22,-18.21 -1.97,-13.06 7.56,-26.65 20.63,-28.93 0.53,-0.08 1.57,-0.24 2.1,-0.32 z"
  })), React.createElement("path", {
    d: "m 373.52872,234.81757 c 2.04889,-5.80734 2.11061,-11.91596 3.36957,-17.83757 2.04889,2.65953 3.57939,5.8385 6.86256,7.63577 0.62948,0.78954 1.32067,1.53754 1.98718,2.30631 -1.18491,7.50071 -3.4066,15.00142 -8.73866,21.2347 -1.92547,0.11428 -3.82625,0.22855 -5.73937,0.35322 0.33325,0.31166 0.99976,0.9246 1.33302,1.22588 -0.65417,0.0831 -1.93781,0.24933 -2.59198,0.33244 -1.48113,-0.21817 -2.96225,-0.4675 -4.43104,-0.73761 1.99952,-3.17897 4.23356,-6.25405 5.87514,-9.58885 0.76525,-1.62066 1.45644,-3.26209 2.07358,-4.92429 z",
    id: "path6198",
    style: {
      opacity: 1,
      fill: "#b3b3b3",
      fillOpacity: 1,
      strokeWidth: 1.13236988
    }
  }), React.createElement("path", {
    d: "m 636.74114,227.59515 c 1.18988,-0.51595 2.37976,-0.98276 3.5982,-1.40043 -3.41734,14.24995 -7.53908,28.20509 -10.42336,42.66388 -2.54159,11.35083 -4.03608,23.04563 -6.71092,34.33503 -0.98047,-5.08576 -2.00852,-10.15924 -3.37927,-15.09758 -0.54258,-1.7444 -0.61873,-3.6362 -0.25702,-5.4543 2.29409,-13.77087 5.14981,-27.39431 8.42437,-40.8335 0.76152,-3.1571 1.42785,-6.35106 1.82765,-9.61872 2.38928,-1.30215 4.65481,-2.96056 6.92035,-4.59438 z",
    id: "path6202",
    style: {
      opacity: 1,
      fill: "#b3b3b3",
      fillOpacity: 1,
      strokeWidth: 1.08137071
    }
  }), React.createElement("path", {
    transform: "scale(0.74999999)",
    id: "path5752",
    d: "m 538.66602,49.253906 c -6.50667,0.04 -13.31946,-0.666927 -19.43946,2.066406 -12.38666,4.920001 -20.37315,18.092292 -20.14648,31.265626 V 272.01367 c -0.0533,9.56 2.65333,19.13375 8,27.09375 0.68,1.01334 1.42648,1.97232 2.14648,2.95899 8.97334,12 23.87977,18.8001 38.75977,18.77343 92.89333,0.0933 185.78635,0.001 278.67969,0.041 4.61333,0.0667 9.42744,0.34654 13.80078,-1.4668 3.34666,-1.41333 6.52002,-3.21495 9.69336,-4.98828 5.32,-4.17333 8.6263,-10.33182 10.29296,-16.78516 16.34667,-59.86666 38.92,-117.8402 64,-174.54687 7.94667,-15.48 6.32071,-35.226614 -3.27929,-49.613281 -1.64,-2.253334 -3.33469,-4.467969 -5.05469,-6.667969 -8.85333,-10.506667 -22.35906,-16.86526 -36.03906,-17.558594 -113.8,0.01333 -227.61406,0 -341.41406,0 z m 339.9746,11.279297 c 11.48001,0.48 22.69334,5.919505 30,14.826172 9.60001,11.413333 12.38649,28.374345 6.14649,42.041015 -20.4,45.41333 -39.18693,91.62622 -53.93359,139.21289 -4.2,13.33333 -8.05352,26.78724 -11.85352,40.25391 -2.01333,7.42666 -9.32026,12.74549 -16.93359,12.79883 -94.24001,-0.0933 -188.49242,-0.0127 -282.73243,-0.0527 -8.69017,0.18969 -17.40648,-2.47283 -24.30859,-7.78125 l -0.24219,0.0645 c 0,0 -1.06237,-0.97103 -1.75781,-1.5664 -0.18714,-0.16803 -0.41602,-0.27653 -0.59961,-0.44922 -0.15359,-0.14936 -0.28747,-0.32293 -0.43945,-0.47461 -0.23351,-0.22287 -0.24944,-0.19099 -0.48438,-0.43164 -0.22776,-0.2333 -0.37922,-0.49397 -0.59765,-0.73828 -4.14036,-4.4113 -7.57979,-9.65127 -9.15821,-15.49024 -1.86666,-6.06666 -1.35877,-12.47908 -1.41211,-18.73242 0,-59.56 0.0133,-119.10797 0,-178.667967 10.79894,-32.511294 -5.62967,-22.361683 79.41016,-24.687501 z",
    style: {
      opacity: 1,
      fill: "#b3b3b3",
      fillOpacity: 1,
      strokeWidth: 1.33333337
    }
  })), React.createElement("g", {
    id: "boccebanen",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 319.93,258.29 c 8.28,-0.1 16.56,-0.05 24.84,-0.04 0.05,11.25 -0.1,22.5 0.1,33.75 -8.3,0.08 -16.6,0.04 -24.9,0.03 -0.73,-7.02 -0.15,-14.08 -0.33,-21.12 -0.11,-4.21 -0.13,-8.43 0.29,-12.62 m 2.09,1.76 c -0.01,1.71 -0.02,3.42 -0.03,5.13 1.75,0.01 3.51,0.01 5.26,0.01 -0.01,-1.72 -0.01,-3.43 -0.02,-5.14 -1.74,0 -3.48,0 -5.21,0 m 7.74,0 c -0.02,1.71 -0.03,3.43 -0.03,5.15 1.75,-0.01 3.51,-0.02 5.27,-0.02 -0.02,-1.72 -0.04,-3.42 -0.05,-5.13 -1.73,0 -3.47,0 -5.19,0 m 7.45,0.04 c -0.01,1.69 -0.01,3.37 -0.01,5.06 1.86,0 3.71,0 5.57,-0.01 0,-1.68 0,-3.36 0.01,-5.03 -1.86,-0.01 -3.72,-0.01 -5.57,-0.02 M 322,266.55 c 0,2.54 0,5.09 0,7.64 1.75,0 3.49,0 5.25,0.01 0.01,-2.55 0,-5.1 -0.01,-7.65 -1.75,-0.01 -3.5,-0.01 -5.24,0 m 7.74,0 c -0.02,2.55 -0.02,5.1 0,7.65 1.74,-0.01 3.49,-0.01 5.25,-0.01 -0.01,-2.55 -0.01,-5.09 0.01,-7.63 -1.76,-0.02 -3.51,-0.02 -5.26,-0.01 m 7.45,0.04 c 0.02,2.52 0.02,5.04 0.03,7.57 1.84,0 3.69,0 5.54,-0.01 0,-2.52 0,-5.04 0.03,-7.55 -1.87,-0.02 -3.74,-0.03 -5.6,-0.01 M 322,275.55 c 0,2.48 0,4.97 0,7.46 1.75,0 3.5,-0.01 5.25,-0.01 0.01,-2.48 0,-4.97 -0.01,-7.45 -1.75,-0.01 -3.5,-0.01 -5.24,0 m 7.74,0 c -0.02,2.48 -0.02,4.97 -0.01,7.45 1.75,0 3.5,0 5.26,0 -0.01,-2.48 -0.01,-4.96 0.01,-7.44 -1.76,-0.02 -3.51,-0.02 -5.26,-0.01 m 7.46,0.04 c 0.01,2.46 0.01,4.93 0.01,7.4 1.85,0 3.7,-0.01 5.56,-0.02 -0.01,-2.46 -0.01,-4.92 0.02,-7.37 -1.87,-0.02 -3.73,-0.03 -5.59,-0.01 m -15.17,8.66 c 0.02,1.79 0.05,3.59 0.1,5.38 1.71,-0.1 3.42,-0.18 5.14,-0.26 0.06,-1.66 0.13,-3.32 0.22,-4.97 -1.82,-0.06 -3.64,-0.1 -5.46,-0.15 m 7.47,0.14 c 0.08,1.66 0.15,3.32 0.21,4.98 1.71,0.08 3.42,0.16 5.14,0.26 0.05,-1.79 0.08,-3.58 0.1,-5.37 -1.82,0.04 -3.64,0.08 -5.45,0.13 m 7.74,-0.09 c 0,1.74 0,3.48 0.01,5.23 1.82,-0.02 3.65,-0.02 5.48,0 0,-1.75 0.01,-3.49 0.01,-5.23 -1.83,0 -3.67,0 -5.5,0 z",
    id: "path5717",
    style: {
      opacity: 1,
      fill: "#d7d8d7"
    }
  }), React.createElement("path", {
    d: "m 322.02,260.05 c 1.73,0 3.47,0 5.21,0 0.01,1.71 0.01,3.42 0.02,5.14 -1.75,0 -3.51,0 -5.26,-0.01 0.01,-1.71 0.02,-3.42 0.03,-5.13 z",
    id: "path6287",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 329.76,260.05 c 1.72,0 3.46,0 5.19,0 0.01,1.71 0.03,3.41 0.05,5.13 -1.76,0 -3.52,0.01 -5.27,0.02 0,-1.72 0.01,-3.44 0.03,-5.15 z",
    id: "path6289",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 337.21,260.09 c 1.85,0.01 3.71,0.01 5.57,0.02 -0.01,1.67 -0.01,3.35 -0.01,5.03 -1.86,0.01 -3.71,0.01 -5.57,0.01 0,-1.69 0,-3.37 0.01,-5.06 z",
    id: "path6291",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 322,266.55 c 1.74,-0.01 3.49,-0.01 5.24,0 0.01,2.55 0.02,5.1 0.01,7.65 -1.76,-0.01 -3.5,-0.01 -5.25,-0.01 0,-2.55 0,-5.1 0,-7.64 z",
    id: "path6299",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 329.74,266.55 c 1.75,-0.01 3.5,-0.01 5.26,0.01 -0.02,2.54 -0.02,5.08 -0.01,7.63 -1.76,0 -3.51,0 -5.25,0.01 -0.02,-2.55 -0.02,-5.1 0,-7.65 z",
    id: "path6301",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 337.19,266.59 c 1.86,-0.02 3.73,-0.01 5.6,0.01 -0.03,2.51 -0.03,5.03 -0.03,7.55 -1.85,0.01 -3.7,0.01 -5.54,0.01 -0.01,-2.53 -0.01,-5.05 -0.03,-7.57 z",
    id: "path6303",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 322,275.55 c 1.74,-0.01 3.49,-0.01 5.24,0 0.01,2.48 0.02,4.97 0.01,7.45 -1.75,0 -3.5,0.01 -5.25,0.01 0,-2.49 0,-4.98 0,-7.46 z",
    id: "path6305",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 329.74,275.55 c 1.75,-0.01 3.5,-0.01 5.26,0.01 -0.02,2.48 -0.02,4.96 -0.01,7.44 -1.76,0 -3.51,0 -5.26,0 -0.01,-2.48 -0.01,-4.97 0.01,-7.45 z",
    id: "path6307",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 337.2,275.59 c 1.86,-0.02 3.72,-0.01 5.59,0.01 -0.03,2.45 -0.03,4.91 -0.02,7.37 -1.86,0.01 -3.71,0.02 -5.56,0.02 0,-2.47 0,-4.94 -0.01,-7.4 z",
    id: "path6309",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 322.03,284.25 c 1.82,0.05 3.64,0.09 5.46,0.15 -0.09,1.65 -0.16,3.31 -0.22,4.97 -1.72,0.08 -3.43,0.16 -5.14,0.26 -0.05,-1.79 -0.08,-3.59 -0.1,-5.38 z",
    id: "path6321",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 329.5,284.39 c 1.81,-0.05 3.63,-0.09 5.45,-0.13 -0.02,1.79 -0.05,3.58 -0.1,5.37 -1.72,-0.1 -3.43,-0.18 -5.14,-0.26 -0.06,-1.66 -0.13,-3.32 -0.21,-4.98 z",
    id: "path6323",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 337.24,284.3 c 1.83,0 3.67,0 5.5,0 0,1.74 -0.01,3.48 -0.01,5.23 -1.83,-0.02 -3.66,-0.02 -5.48,0 -0.01,-1.75 -0.01,-3.49 -0.01,-5.23 z",
    id: "path6325",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  })), React.createElement("g", {
    id: "Kanjer arena",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 316.04,292.05 c 1.3,-0.02 2.61,-0.02 3.93,-0.02 8.3,0.01 16.6,0.05 24.9,-0.03 2.18,-0.02 4.37,0.01 6.54,0.25 -0.43,0.18 -1.29,0.53 -1.72,0.71 -10.88,0.42 -21.79,0.05 -32.68,0.17 -0.08,16.24 0.12,32.48 -0.09,48.72 -0.19,0.41 -0.56,1.24 -0.74,1.65 -0.46,-17.13 -0.18,-34.3 -0.14,-51.45 z",
    id: "path6145",
    style: {
      opacity: 1,
      fill: "#9f9e9e",
      fillOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 351.41,292.25 0.71,-0.3 c -0.15,16.36 0.02,32.72 -0.06,49.07 0.15,1.33 -0.44,3.19 -2.13,2.98 -11.34,0.27 -22.7,-0.12 -34.05,0.16 l 0.3,-0.66 c 0.18,-0.41 0.55,-1.24 0.74,-1.65 10.99,0.05 21.98,0.04 32.97,0.08 -0.02,-16.32 0.29,-32.65 -0.2,-48.97 0.43,-0.18 1.29,-0.53 1.72,-0.71 z",
    id: "path6216",
    style: {
      opacity: 1,
      fill: "#9f9e9e"
    }
  }), React.createElement("path", {
    d: "m 327.23,294.34 c 4.29,0.07 8.58,0.06 12.87,0 0.05,1.61 0.09,3.23 0.14,4.85 -4.36,-0.08 -8.72,-0.02 -13.08,0 0.02,-1.62 0.04,-3.23 0.07,-4.85 z",
    id: "path6331",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 342.25,294.49 c 2.27,-0.23 4.56,-0.14 6.85,-0.16 0.34,7.62 0.21,15.25 0.12,22.87 -3.04,0.01 -6.09,0.18 -9.11,-0.08 -1.98,-1.87 -3.58,-5.18 -6.83,-4.63 -2.75,0.09 -4.11,2.68 -5.43,4.69 -3.25,0.04 -6.51,0.04 -9.76,0.02 0.04,-7.59 0.05,-15.17 -0.01,-22.76 2.62,-0.04 5.23,-0.04 7.85,-0.01 0.04,1.93 0.09,3.87 0.17,5.8 2.72,0.61 5.14,2.18 7.89,2.65 2.54,-0.69 4.89,-1.97 7.43,-2.71 0.33,-1.84 -0.65,-4.32 0.83,-5.68 z",
    id: "path6333",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 332.51,300.26 c 0.78,-0.95 2.94,-0.9 3.15,0.53 -0.21,1.82 -4.29,1.44 -3.15,-0.53 z",
    id: "path6335",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 329.36,317.07 c 1.18,-1.49 2.36,-3.65 4.62,-3.28 2.09,-0.09 3.12,2.02 4.41,3.29 -3.01,0.16 -6.03,0.16 -9.03,-0.01 z",
    id: "path6337",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 329.47,318.64 c 2.94,-0.13 5.89,-0.12 8.84,0 -1.24,1.3 -2.33,3.32 -4.39,3.24 -2.16,0.23 -3.34,-1.76 -4.45,-3.24 z",
    id: "path6343",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 318.08,318.59 c 3.25,-0.05 6.49,-0.06 9.75,0 1.51,2.06 3.18,4.94 6.2,4.49 2.89,0.22 4.35,-2.59 5.84,-4.55 3.11,0.02 6.23,0.02 9.35,0.06 0.11,7.56 0.13,15.13 0.01,22.7 -2.56,0.01 -5.13,0 -7.68,-0.02 -0.04,-1.87 -0.05,-3.74 -0.06,-5.6 -2.58,-0.78 -4.91,-2.2 -7.49,-2.95 -2.76,0.61 -5.2,2.18 -7.95,2.86 -0.04,1.89 -0.08,3.79 -0.12,5.69 -2.61,0.01 -5.23,0.01 -7.84,0 0.03,-7.56 0.06,-15.12 -0.01,-22.68 z",
    id: "path6345",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 332.53,334.31 c 0.61,-0.96 3.08,-0.88 2.83,0.56 -0.62,0.98 -3.09,0.88 -2.83,-0.56 z",
    id: "path6357",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 327.16,336.6 c 4.34,-0.07 8.69,-0.07 13.04,-0.03 -0.01,1.57 -0.02,3.15 -0.03,4.73 -4.33,0.04 -8.66,0.02 -12.98,-0.04 -0.01,-1.55 -0.02,-3.11 -0.03,-4.66 z",
    id: "path6361",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  })), React.createElement("g", {
    id: "mini arena veld 2",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 401.02,335.17 c 0.08,-0.63 0.25,-1.89 0.34,-2.52 0.23,0.83 0.7,2.51 0.93,3.34 1.15,-1.12 2.31,-2.22 3.51,-3.28 -0.73,1.21 -1.49,2.4 -2.26,3.6 0.83,1.56 1.69,3.12 2.5,4.7 -1.23,-1.02 -2.41,-2.08 -3.6,-3.13 -0.46,1.15 -0.93,2.3 -1.4,3.45 -0.07,-0.89 -0.2,-2.67 -0.27,-3.57 0.07,-0.64 0.19,-1.94 0.25,-2.59 z",
    id: "path5922",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    d: "m 413.31,334.01 c 2.01,-0.99 4.15,-0.72 6.14,0.23 -0.24,0.36 -0.72,1.09 -0.96,1.46 -0.84,1.31 -1.67,2.62 -2.5,3.93 1.09,0.41 2.19,0.83 3.3,1.26 -1.8,0.01 -3.59,-0.01 -5.37,-0.02 1.41,-2.11 2.74,-4.28 3.72,-6.62 -1.45,-0.08 -2.89,-0.16 -4.33,-0.24 z",
    id: "path5926",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    transform: "scale(0.74999999)",
    id: "path4398",
    d: "m 499.2207,417.47852 c -1.5e-4,21.57768 0.0457,43.15833 0.006,64.73437 31.50667,0.0267 63.01287,-0.0523 94.51953,0.041 0.11959,-21.5918 0.0259,-43.1836 0.0195,-64.77539 z",
    style: {
      fill: "#ffffff",
      strokeWidth: 1
    }
  }), React.createElement("path", {
    transform: "scale(0.74999999)",
    id: "rect4343",
    d: "m 496.96094,417.47852 c -0.003,22.63148 -0.0864,45.26304 0,67.89453 33.12,0.08 66.22536,0.0667 99.33203,0 0.0731,-22.63149 10e-4,-45.26305 0,-67.89453 h -2.52735 c 0.006,21.59179 0.10006,43.18359 -0.0195,64.77539 -31.50666,-0.0933 -63.01286,-0.0144 -94.51953,-0.041 0.0399,-21.57604 -0.006,-43.15669 -0.006,-64.73437 z",
    style: {
      fill: "#25a951",
      fillOpacity: 1,
      strokeWidth: 1
    }
  }), React.createElement("path", {
    d: "m 384.66,330.79 c 3.3,-1.12 6.9,-0.85 10.31,-0.56 2.83,0.26 4.27,3.09 6.05,4.94 -0.06,0.65 -0.18,1.95 -0.25,2.59 -0.74,2.33 -2.42,4.59 -4.94,5.09 -3.72,0.73 -7.71,0.8 -11.33,-0.38 -4.38,-2.26 -4.46,-9.66 0.16,-11.68 m -0.47,1.38 c -2.6,1.86 -2.71,5.89 -0.71,8.23 1.2,1.78 3.6,1.66 5.46,2.22 -1.91,-3.88 -1.83,-8.12 -0.1,-12.04 -1.57,0.47 -3.19,0.83 -4.65,1.59 m 8.15,-1 c -4.07,0.79 -5.6,6.26 -2.85,9.24 2.85,3.84 10.33,1.57 9.97,-3.42 0.35,-3.65 -3.57,-6.99 -7.12,-5.82 z",
    id: "path6222",
    style: {
      opacity: 1,
      fill: "#9f9e9e"
    }
  }), React.createElement("path", {
    d: "m 419.45,334.24 c 2.62,-5.4 9.47,-4.39 14.38,-3.88 5.45,1 6.55,9.54 1.65,12.05 -3.65,1.23 -7.65,1.12 -11.41,0.54 -3.57,-0.48 -4.38,-4.51 -5.58,-7.25 0.24,-0.37 0.72,-1.1 0.96,-1.46 m 4.87,-3.07 c -3.88,0.87 -5.36,6.27 -2.81,9.19 2.58,3.57 9.5,2.16 9.94,-2.41 0.98,-4.01 -3.18,-8.06 -7.13,-6.78 m 5.91,-0.51 c 0.83,1.83 1.86,3.6 2.33,5.58 -0.05,2.22 -0.98,4.29 -1.52,6.41 1.44,-0.39 2.91,-0.7 4.3,-1.27 2.63,-1.58 2.7,-5.43 1.34,-7.87 -1.2,-2.43 -4.2,-2.28 -6.45,-2.85 z",
    id: "path6224",
    style: {
      opacity: 1,
      fill: "#9f9e9e"
    }
  }), React.createElement("path", {
    d: "m 375.77,313.68 c 30.006,-0.21137 30.09157,-0.19513 68.32,0 0.03,15.55 0.03,31.1 0,46.65 -6.06,0.04 -12.11,0.05 -18.17,-0.01 -0.02,-4.01 -0.03,-8.03 0,-12.04 -2.62,-0.21 -5.71,0.63 -7.76,-1.48 -2.69,-2.37 -6.23,-4.04 -9.89,-3.35 -3.36,0.34 -5.66,3 -8.41,4.62 -1.94,0.24 -3.9,0.17 -5.85,0.2 -0.03,4.02 -0.04,8.03 -0.03,12.05 -6.07,0.06 -12.14,0.05 -18.21,0.01 -0.03,-15.55 -0.02,-31.1 0,-46.65",
    id: "path6339",
    style: {
      opacity: 1,
      fill: "#25a951",
      fillOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 402.35,347.98 c 3.99,-4.39 11.24,-4.36 15.23,0.02 -5.07,0.34 -10.17,0.36 -15.23,-0.02 z",
    id: "path6365",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 395.19,349.62 c 9.82,-0.09 19.64,-0.18 29.47,0.05 -0.07,3.53 -0.07,7.07 0,10.6 -9.82,0.14 -19.64,0.09 -29.47,0.03 0.04,-3.56 0.04,-7.12 0,-10.68 z",
    id: "path6367",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  })), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fff1cc"
    },
    id: "path6370",
    d: "m 257.85,258.4 c 18.71,-0.02 37.42,-0.05 56.13,0.01 -0.03,27.99 -0.02,55.97 0,83.95 -18.71,0.03 -37.41,0.02 -56.11,0 -0.01,-27.98 -0.03,-55.97 -0.02,-83.96 m 6.2,3.61 c -0.12,7.04 -0.07,14.09 -0.05,21.13 5.35,0.25 10.7,0.1 16.05,0.08 2.01,-0.12 3.91,0.55 5.72,1.34 1.32,-0.62 2.64,-1.37 4.15,-1.3 5.82,-0.08 11.63,0.16 17.45,-0.1 0.23,-7.05 0.24,-14.11 -0.02,-21.16 -7.12,-0.38 -14.46,0.94 -21.4,-1.17 -7.09,2.14 -14.61,0.76 -21.9,1.18 m 16,27.78 c -5.35,-0.03 -10.7,-0.17 -16.05,0.08 -0.01,7.03 -0.1,14.06 0.08,21.09 5.65,0.13 11.31,-0.02 16.96,0.07 1.72,-0.12 3.26,0.68 4.75,1.4 1.31,-0.64 2.61,-1.45 4.13,-1.38 5.8,-0.13 11.6,0.02 17.41,-0.05 0.31,-7.05 0.27,-14.11 0.04,-21.15 -5.48,-0.22 -10.97,-0.09 -16.45,-0.07 -1.82,0.11 -3.54,-0.49 -5.13,-1.3 -1.83,0.77 -3.74,1.42 -5.74,1.31 m -15.95,27.35 c -0.22,7.07 -0.11,14.14 -0.09,21.21 6.82,0.36 13.65,0.26 20.48,0.08 0.21,0.69 0.63,2.06 0.83,2.75 0.74,-0.87 1.46,-1.75 2.19,-2.62 6.62,-0.02 13.24,0.12 19.86,-0.15 0.21,-7.11 0.29,-14.24 -0.07,-21.35 -7.11,-0.38 -14.39,0.93 -21.33,-1.11 -7.09,2.09 -14.58,0.65 -21.87,1.19 z"
  }), React.createElement("g", {
    id: "beachveld 1",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 278.54,268.26 c 1.39,2.24 2.3,4.73 3.28,7.18 0.92,-2.32 1.81,-4.65 2.73,-6.97 -0.02,1.25 -0.14,2.49 -0.37,3.72 -0.7,1.91 -1.5,3.78 -2.35,5.63 -1.64,-2.97 -2.86,-6.18 -3.29,-9.56 z",
    id: "path5846",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    d: "m 289.02,270.15 c 0.97,-0.4 1.93,-0.81 2.9,-1.22 0.02,2.27 0.04,4.53 0.06,6.8 0.57,0.32 1.7,0.96 2.26,1.28 -1.9,0.06 -3.8,0.06 -5.7,0 0.64,-0.37 1.92,-1.12 2.56,-1.5 -0.25,-1.99 0.4,-4.62 -2.08,-5.36 z",
    id: "path5848",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    d: "m 264.05,262.01 c 7.29,-0.42 14.81,0.96 21.9,-1.18 6.94,2.11 14.28,0.79 21.4,1.17 0.26,7.05 0.25,14.11 0.02,21.16 -5.82,0.26 -11.63,0.02 -17.45,0.1 -1.51,-0.07 -2.83,0.68 -4.15,1.3 -1.81,-0.79 -3.71,-1.46 -5.72,-1.34 -5.35,0.02 -10.7,0.17 -16.05,-0.08 -0.02,-7.04 -0.07,-14.09 0.05,-21.13 m 1.97,1.99 c -0.03,5.94 -0.04,11.87 0.05,17.8 6.3,-0.11 12.6,-0.11 18.91,0.01 0.06,-3.49 0.04,-6.99 -0.47,-10.45 l -0.33,0.83 c 0.23,-1.23 0.35,-2.47 0.37,-3.72 0.38,-1.45 0.41,-2.95 0.56,-4.42 -6.36,-0.1 -12.73,-0.04 -19.09,-0.05 m 20.92,0.02 c -0.12,5.91 -0.13,11.83 0.09,17.75 6.29,-0.06 12.58,-0.07 18.87,0.01 0.11,-5.92 0.1,-11.84 0.06,-17.76 -6.34,-0.03 -12.68,-0.03 -19.02,0 z",
    id: "path6208",
    style: {
      opacity: 1,
      fill: "#9f9e9e"
    }
  }), React.createElement("path", {
    d: "m 266.02,264 c 6.36,0.01 12.73,-0.05 19.09,0.05 -0.15,1.47 -0.18,2.97 -0.56,4.42 -0.92,2.32 -1.81,4.65 -2.73,6.97 -0.98,-2.45 -1.89,-4.94 -3.28,-7.18 0.43,3.38 1.65,6.59 3.29,9.56 0.85,-1.85 1.65,-3.72 2.35,-5.63 l 0.33,-0.83 c 0.51,3.46 0.53,6.96 0.47,10.45 -6.31,-0.12 -12.61,-0.12 -18.91,-0.01 -0.09,-5.93 -0.08,-11.86 -0.05,-17.8 z",
    id: "path6372",
    style: {
      opacity: 1,
      fill: "#fff1cc"
    }
  }), React.createElement("path", {
    d: "m 286.94,264.02 c 6.34,-0.03 12.68,-0.03 19.02,0 0.04,5.92 0.05,11.84 -0.06,17.76 -6.29,-0.08 -12.58,-0.07 -18.87,-0.01 -0.22,-5.92 -0.21,-11.84 -0.09,-17.75 m 2.08,6.13 c 2.48,0.74 1.83,3.37 2.08,5.36 -0.64,0.38 -1.92,1.13 -2.56,1.5 1.9,0.06 3.8,0.06 5.7,0 -0.56,-0.32 -1.69,-0.96 -2.26,-1.28 -0.02,-2.27 -0.04,-4.53 -0.06,-6.8 -0.97,0.41 -1.93,0.82 -2.9,1.22 z",
    id: "path6374",
    style: {
      opacity: 1,
      fill: "#fff1cc"
    }
  })), React.createElement("g", {
    id: "beachveld 2",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 288.28,297.24 c 1.53,-0.65 3.33,-1.42 4.78,-0.11 0.85,2.44 -1.38,4.28 -2.53,6.15 0.81,0.06 2.43,0.17 3.25,0.22 -0.05,0.23 -0.15,0.68 -0.2,0.91 -1.68,-0.04 -3.37,-0.08 -5.05,-0.14 1.45,-2.07 3.01,-4.08 4.05,-6.4 -1.08,-0.16 -3.23,-0.47 -4.3,-0.63 z",
    id: "path5882",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    d: "m 266.08,291.22 c 6.36,0.11 12.72,0.04 19.08,0.05 -0.26,3.79 -2,7.19 -3.48,10.61 -0.73,-2.39 -1.34,-5.03 -3.6,-6.47 0.69,3.37 1.27,7.12 3.87,9.62 1.21,-1.94 2.09,-4.05 3.04,-6.12 0.01,3.35 0,6.71 0.01,10.07 -6.33,0.02 -12.66,0.03 -18.98,0 -0.03,-5.92 -0.05,-11.84 0.06,-17.76 z",
    id: "path6376",
    style: {
      opacity: 1,
      fill: "#fff1cc"
    }
  }), React.createElement("g", {
    id: "g4500"
  }, React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#9f9e9e"
    },
    id: "path6214",
    d: "m 280.05,289.79 c 2,0.11 3.91,-0.54 5.74,-1.31 1.59,0.81 3.31,1.41 5.13,1.3 5.48,-0.02 10.97,-0.15 16.45,0.07 0.23,7.04 0.27,14.1 -0.04,21.15 -5.81,0.07 -11.61,-0.08 -17.41,0.05 -1.52,-0.07 -2.82,0.74 -4.13,1.38 -1.49,-0.72 -3.03,-1.52 -4.75,-1.4 -5.65,-0.09 -11.31,0.06 -16.96,-0.07 -0.18,-7.03 -0.09,-14.06 -0.08,-21.09 5.35,-0.25 10.7,-0.11 16.05,-0.08 m -13.97,1.43 c -0.11,5.92 -0.09,11.84 -0.06,17.76 6.32,0.03 12.65,0.02 18.98,0 -0.01,-3.36 0,-6.72 -0.01,-10.07 -0.95,2.07 -1.83,4.18 -3.04,6.12 -2.6,-2.5 -3.18,-6.25 -3.87,-9.62 2.26,1.44 2.87,4.08 3.6,6.47 1.48,-3.42 3.22,-6.82 3.48,-10.61 -6.36,-0.01 -12.72,0.06 -19.08,-0.05 m 20.96,0.02 c -0.24,5.9 -0.21,11.82 -0.11,17.73 6.35,0.04 12.69,0.03 19.04,0.01 0.03,-5.92 0.04,-11.84 -0.07,-17.76 -6.29,0.09 -12.58,0.08 -18.86,0.02 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fff1cc"
    },
    id: "path6378",
    d: "m 287.04,291.24 c 6.28,0.06 12.57,0.07 18.86,-0.02 0.11,5.92 0.1,11.84 0.07,17.76 -6.35,0.02 -12.69,0.03 -19.04,-0.01 -0.1,-5.91 -0.13,-11.83 0.11,-17.73 m 1.24,6 c 1.07,0.16 3.22,0.47 4.3,0.63 -1.04,2.32 -2.6,4.33 -4.05,6.4 1.68,0.06 3.37,0.1 5.05,0.14 0.05,-0.23 0.15,-0.68 0.2,-0.91 -0.82,-0.05 -2.44,-0.16 -3.25,-0.22 1.15,-1.87 3.38,-3.71 2.53,-6.15 -1.45,-1.31 -3.25,-0.54 -4.78,0.11 z"
  }))), React.createElement("g", {
    id: "beachveld 3",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 264.1,317.14 c 7.29,-0.54 14.78,0.9 21.87,-1.19 6.94,2.04 14.22,0.73 21.33,1.11 0.36,7.11 0.28,14.24 0.07,21.35 -6.62,0.27 -13.24,0.13 -19.86,0.15 -0.73,0.87 -1.45,1.75 -2.19,2.62 -0.2,-0.69 -0.62,-2.06 -0.83,-2.75 -6.83,0.18 -13.66,0.28 -20.48,-0.08 -0.02,-7.07 -0.13,-14.14 0.09,-21.21 m 1.92,1.88 c -0.03,5.98 -0.03,11.97 -0.01,17.96 6.33,0.02 12.66,0.02 18.98,0 0.05,-3.53 -0.02,-7.06 -0.54,-10.55 0.06,-0.54 0.19,-1.61 0.26,-2.14 l -0.47,0.89 c 0.72,-1.96 0.66,-4.08 0.84,-6.13 -6.35,-0.08 -12.71,-0.05 -19.06,-0.03 m 20.91,0.01 c -0.09,5.98 -0.09,11.96 -0.01,17.94 6.35,0.04 12.7,0.03 19.05,0 0.01,-5.98 0.01,-11.96 0,-17.95 -6.35,-0.03 -12.69,-0.03 -19.04,0.01 z",
    id: "path6220",
    style: {
      opacity: 1,
      fill: "#9f9e9e"
    }
  }), React.createElement("g", {
    id: "g4492"
  }, React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000"
    },
    id: "path5916",
    d: "m 288.32,325.18 c 1.47,-0.26 3.13,-0.98 4.49,0.04 0.31,2.05 0.65,4.13 0.56,6.21 -1.4,1.97 -3.87,0.91 -5.71,0.4 1.7,-0.23 3.39,-0.45 5.09,-0.67 -0.43,-1.83 -2.05,-2.22 -3.66,-2.51 1.2,-0.68 2.39,-1.4 3.53,-2.18 -1.08,-0.32 -3.23,-0.97 -4.3,-1.29 z"
  }), React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000000"
    },
    id: "path5918",
    d: "m 278.6,324.07 c 1.33,2.08 2.22,4.39 3.2,6.66 0.82,-1.85 1.59,-3.72 2.44,-5.55 l 0.47,-0.89 c -0.07,0.53 -0.2,1.6 -0.26,2.14 -0.67,2.42 -1.59,4.76 -2.57,7.06 -1.56,-2.95 -2.84,-6.09 -3.28,-9.42 z"
  }), React.createElement("g", {
    id: "g4504"
  }, React.createElement("path", {
    d: "m 266.02,319.02 c 6.35,-0.02 12.71,-0.05 19.06,0.03 -0.18,2.05 -0.12,4.17 -0.84,6.13 -0.85,1.83 -1.62,3.7 -2.44,5.55 -0.98,-2.27 -1.87,-4.58 -3.2,-6.66 0.44,3.33 1.72,6.47 3.28,9.42 0.98,-2.3 1.9,-4.64 2.57,-7.06 0.52,3.49 0.59,7.02 0.54,10.55 -6.32,0.02 -12.65,0.02 -18.98,0 -0.02,-5.99 -0.02,-11.98 0.01,-17.96 z",
    id: "path6380",
    style: {
      opacity: 1,
      fill: "#fff1cc"
    }
  }), React.createElement("path", {
    d: "m 286.93,319.03 c 6.35,-0.04 12.69,-0.04 19.04,-0.01 0.01,5.99 0.01,11.97 0,17.95 -6.35,0.03 -12.7,0.04 -19.05,0 -0.08,-5.98 -0.08,-11.96 0.01,-17.94 m 1.39,6.15 c 1.07,0.32 3.22,0.97 4.3,1.29 -1.14,0.78 -2.33,1.5 -3.53,2.18 1.61,0.29 3.23,0.68 3.66,2.51 -1.7,0.22 -3.39,0.44 -5.09,0.67 1.84,0.51 4.31,1.57 5.71,-0.4 0.09,-2.08 -0.25,-4.16 -0.56,-6.21 -1.36,-1.02 -3.02,-0.3 -4.49,-0.04 z",
    id: "path6382",
    style: {
      opacity: 1,
      fill: "#fff1cc"
    }
  })))), React.createElement("g", {
    transform: "matrix(1,0,0,-1,7.8946589e-7,626.2591)",
    id: "mini arena veld 1",
    className: "selectable"
  }, React.createElement("path", {
    d: "m 401.02,335.17 c 0.08,-0.63 0.25,-1.89 0.34,-2.52 0.23,0.83 0.7,2.51 0.93,3.34 1.15,-1.12 2.31,-2.22 3.51,-3.28 -0.73,1.21 -1.49,2.4 -2.26,3.6 0.83,1.56 1.69,3.12 2.5,4.7 -1.23,-1.02 -2.41,-2.08 -3.6,-3.13 -0.46,1.15 -0.93,2.3 -1.4,3.45 -0.07,-0.89 -0.2,-2.67 -0.27,-3.57 0.07,-0.64 0.19,-1.94 0.25,-2.59 z",
    id: "path5922-2",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    d: "m 413.31,334.01 c 2.01,-0.99 4.15,-0.72 6.14,0.23 -0.24,0.36 -0.72,1.09 -0.96,1.46 -0.84,1.31 -1.67,2.62 -2.5,3.93 1.09,0.41 2.19,0.83 3.3,1.26 -1.8,0.01 -3.59,-0.01 -5.37,-0.02 1.41,-2.11 2.74,-4.28 3.72,-6.62 -1.45,-0.08 -2.89,-0.16 -4.33,-0.24 z",
    id: "path5926-7",
    style: {
      opacity: 1,
      fill: "#000000"
    }
  }), React.createElement("path", {
    transform: "scale(0.74999999)",
    id: "path4398-0",
    d: "m 499.2207,417.47852 c -1.5e-4,21.57768 0.0457,43.15833 0.006,64.73437 31.50667,0.0267 63.01287,-0.0523 94.51953,0.041 0.11959,-21.5918 0.0259,-43.1836 0.0195,-64.77539 z",
    style: {
      fill: "#ffffff",
      strokeWidth: 1
    }
  }), React.createElement("path", {
    transform: "scale(0.74999999)",
    id: "rect4343-3",
    d: "m 496.96094,417.47852 c -0.003,22.63148 -0.0864,45.26304 0,67.89453 33.12,0.08 66.22536,0.0667 99.33203,0 0.0731,-22.63149 10e-4,-45.26305 0,-67.89453 h -2.52735 c 0.006,21.59179 0.10006,43.18359 -0.0195,64.77539 -31.50666,-0.0933 -63.01286,-0.0144 -94.51953,-0.041 0.0399,-21.57604 -0.006,-43.15669 -0.006,-64.73437 z",
    style: {
      fill: "#25a951",
      fillOpacity: 1,
      strokeWidth: 1
    }
  }), React.createElement("path", {
    d: "m 384.66,330.79 c 3.3,-1.12 6.9,-0.85 10.31,-0.56 2.83,0.26 4.27,3.09 6.05,4.94 -0.06,0.65 -0.18,1.95 -0.25,2.59 -0.74,2.33 -2.42,4.59 -4.94,5.09 -3.72,0.73 -7.71,0.8 -11.33,-0.38 -4.38,-2.26 -4.46,-9.66 0.16,-11.68 m -0.47,1.38 c -2.6,1.86 -2.71,5.89 -0.71,8.23 1.2,1.78 3.6,1.66 5.46,2.22 -1.91,-3.88 -1.83,-8.12 -0.1,-12.04 -1.57,0.47 -3.19,0.83 -4.65,1.59 m 8.15,-1 c -4.07,0.79 -5.6,6.26 -2.85,9.24 2.85,3.84 10.33,1.57 9.97,-3.42 0.35,-3.65 -3.57,-6.99 -7.12,-5.82 z",
    id: "path6222-0",
    style: {
      opacity: 1,
      fill: "#9f9e9e"
    }
  }), React.createElement("path", {
    d: "m 419.45,334.24 c 2.62,-5.4 9.47,-4.39 14.38,-3.88 5.45,1 6.55,9.54 1.65,12.05 -3.65,1.23 -7.65,1.12 -11.41,0.54 -3.57,-0.48 -4.38,-4.51 -5.58,-7.25 0.24,-0.37 0.72,-1.1 0.96,-1.46 m 4.87,-3.07 c -3.88,0.87 -5.36,6.27 -2.81,9.19 2.58,3.57 9.5,2.16 9.94,-2.41 0.98,-4.01 -3.18,-8.06 -7.13,-6.78 m 5.91,-0.51 c 0.83,1.83 1.86,3.6 2.33,5.58 -0.05,2.22 -0.98,4.29 -1.52,6.41 1.44,-0.39 2.91,-0.7 4.3,-1.27 2.63,-1.58 2.7,-5.43 1.34,-7.87 -1.2,-2.43 -4.2,-2.28 -6.45,-2.85 z",
    id: "path6224-0",
    style: {
      opacity: 1,
      fill: "#9f9e9e"
    }
  }), React.createElement("path", {
    d: "m 375.77,313.68 c 30.006,-0.21137 30.09157,-0.19513 68.32,0 0.03,15.55 0.03,31.1 0,46.65 -6.06,0.04 -12.11,0.05 -18.17,-0.01 -0.02,-4.01 -0.03,-8.03 0,-12.04 -2.62,-0.21 -5.71,0.63 -7.76,-1.48 -2.69,-2.37 -6.23,-4.04 -9.89,-3.35 -3.36,0.34 -5.66,3 -8.41,4.62 -1.94,0.24 -3.9,0.17 -5.85,0.2 -0.03,4.02 -0.04,8.03 -0.03,12.05 -6.07,0.06 -12.14,0.05 -18.21,0.01 -0.03,-15.55 -0.02,-31.1 0,-46.65",
    id: "path6339-5",
    style: {
      opacity: 1,
      fill: "#25a951",
      fillOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 402.35,347.98 c 3.99,-4.39 11.24,-4.36 15.23,0.02 -5.07,0.34 -10.17,0.36 -15.23,-0.02 z",
    id: "path6365-8",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  }), React.createElement("path", {
    d: "m 395.19,349.62 c 9.82,-0.09 19.64,-0.18 29.47,0.05 -0.07,3.53 -0.07,7.07 0,10.6 -9.82,0.14 -19.64,0.09 -29.47,0.03 0.04,-3.56 0.04,-7.12 0,-10.68 z",
    id: "path6367-3",
    style: {
      opacity: 1,
      fill: "#25a951"
    }
  })), React.createElement("g", {
    id: "ATB baan",
    className: "selectable"
  }, React.createElement("path", {
    id: "path158",
    d: "m 406.32607,422.17456 c -9.7218,-1.9211 -26.07607,14.27846 -26.07607,14.27846 -6.22848,1.85156 -4.39849,7.86676 -1.91629,24.6286 3.55654,24.0167 27.70055,47.31599 42.63708,59.86187 14.25882,11.97664 36.77034,26.10782 51.57164,21.47446 14.8013,-4.63336 -14.02229,-55.65127 -14.02229,-55.65127 0,0 -25.03775,-59.22584 -52.19407,-64.59212 z",
    style: {
      fill: "#deaa87",
      stroke: "none",
      strokeWidth: "0.92177719px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlattegrond, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plattegrond.5c93a699.svg";
export { ForwardRef as ReactComponent };